export const LOADING = Symbol("LOADING");
export const ADD_PRODUCT_SETUP = Symbol("ADD_PRODUCT_SETUP");
export const DELETE_PRODUCT_SETUP = Symbol("DELETE_PRODUCT_SETUP");
export const ADD_DEVICE_SETUP = Symbol("ADD_DEVICE_SETUP");
export const DELETE_DEVICE_SETUP = Symbol("DELETE_DEVICE_SETUP");
export const ADD_STAFF_SETUP = Symbol("ADD_STAFF_SETUP");
export const DELETE_STAFF_SETUP = Symbol("DELETE_STAFF_SETUP");
export const SETUP_GUIDE_DATA = Symbol("SETUP_GUIDE_DATA");
